import { SearchPage } from '../components/pages/search/SearchPage'
export default SearchPage
